import { JSONSchemaType } from "ajv"
import validateConstant from "../../../constant/validateConstant"
import util from "../../../ts/util"
import { TOsiraseRegisterPostReq, TOsiraseUpdatePutReq } from "./TOsirase"

export const TOsiraseRegisterPostReqSchema: JSONSchemaType<TOsiraseRegisterPostReq> =
  {
    type: "object",
    properties: {
      掲載開始日: {
        type: "string",
        minLength: 1,
        nullable: false,
        title: "掲載開始日",
        errorMessage: util.stringErrorMessage("掲載開始日", {
          required: true,
        }),
      },
      掲載終了日: {
        type: "string",
        minLength: 1,
        nullable: false,
        title: "掲載終了日",
        errorMessage: util.stringErrorMessage("掲載終了日", {
          required: true,
        }),
      },
      タイトル: {
        type: "string",
        minLength: 1,
        maxLength: validateConstant.LENGTH.一般名称,
        title: "タイトル",
        errorMessage: util.stringErrorMessage("タイトル", {
          required: true,
          maxLength: validateConstant.LENGTH.一般名称,
        }),
      },
      お知らせ分類区分コード: {
        type: "string",
        maxLength: validateConstant.LENGTH.汎用区分コード,
        title: "お知らせ分類区分コード",
        nullable: true,
        errorMessage: util.stringErrorMessage("お知らせ分類区分コード", {
          required: false,
          maxLength: validateConstant.LENGTH.汎用区分コード,
        }),
      },
      部所コード: {
        type: "string",
        minLength: 0,
        maxLength: validateConstant.LENGTH.汎用区分コード,
        title: "部所コード",
        nullable: true,
        errorMessage: util.stringErrorMessage("部所コード", {
          required: false,
          maxLength: validateConstant.LENGTH.汎用区分コード,
        }),
      },
      強調表示フラグ: {
        type: "number",
        title: "強調表示フラグ",
        enum: [0, 1],
        errorMessage: util.stringErrorMessage("強調表示フラグ", {
          required: false,
        }),
      },
      内容: {
        type: "string",
        maxLength: validateConstant.LENGTH.一般テキスト,
        title: "内容",
        nullable: true,
        errorMessage: util.stringErrorMessage("内容", {
          required: false,
          maxLength: validateConstant.LENGTH.一般テキスト,
        }),
      },
      備考: {
        type: "string",
        maxLength: validateConstant.LENGTH.一般テキスト,
        title: "備考",
        nullable: true,
        errorMessage: util.stringErrorMessage("備考", {
          required: false,
          maxLength: validateConstant.LENGTH.一般テキスト,
        }),
      },
    },
    required: ["掲載開始日", "掲載終了日", "タイトル"],
  }
export const TOsiraseUpdatePutReqSchema: JSONSchemaType<TOsiraseUpdatePutReq> =
  {
    type: "object",
    properties: {
      掲載開始日: {
        type: "string",
        minLength: 1,
        nullable: false,
        title: "掲載開始日",
        errorMessage: util.stringErrorMessage("掲載開始日", {
          required: true,
        }),
      },
      掲載終了日: {
        type: "string",
        minLength: 1,
        nullable: false,
        title: "掲載終了日",
        errorMessage: util.stringErrorMessage("掲載終了日", {
          required: true,
        }),
      },
      タイトル: {
        type: "string",
        minLength: 1,
        maxLength: validateConstant.LENGTH.一般名称,
        title: "タイトル",
        errorMessage: util.stringErrorMessage("タイトル", {
          required: true,
          maxLength: validateConstant.LENGTH.一般名称,
        }),
      },
      お知らせ分類区分コード: {
        type: "string",
        maxLength: validateConstant.LENGTH.汎用区分コード,
        title: "お知らせ分類区分コード",
        nullable: true,
        errorMessage: util.stringErrorMessage("お知らせ分類区分コード", {
          required: false,
          maxLength: validateConstant.LENGTH.汎用区分コード,
        }),
      },
      部所コード: {
        type: "string",
        minLength: 0,
        maxLength: validateConstant.LENGTH.汎用区分コード,
        title: "部所コード",
        nullable: true,
        errorMessage: util.stringErrorMessage("部所コード", {
          required: false,
          maxLength: validateConstant.LENGTH.汎用区分コード,
        }),
      },
      強調表示フラグ: {
        type: "number",
        title: "強調表示フラグ",
        enum: [0, 1],
        errorMessage: util.stringErrorMessage("強調表示フラグ", {
          required: false,
        }),
      },
      内容: {
        type: "string",
        maxLength: validateConstant.LENGTH.一般テキスト,
        title: "内容",
        nullable: true,
        errorMessage: util.stringErrorMessage("内容", {
          required: false,
          maxLength: validateConstant.LENGTH.一般テキスト,
        }),
      },
      備考: {
        type: "string",
        maxLength: validateConstant.LENGTH.一般テキスト,
        title: "備考",
        nullable: true,
        errorMessage: util.stringErrorMessage("備考", {
          required: false,
          maxLength: validateConstant.LENGTH.一般テキスト,
        }),
      },
      更新日時: {
        type: "string",
        minLength: 1,
        title: "更新日時",
        errorMessage: util.stringErrorMessage("更新日時", {
          required: true,
        }),
      },
    },
    required: ["更新日時", "掲載開始日", "掲載終了日", "タイトル"],
  }
